import { Card, IconButton } from "@mui/material";
import HeaderGestorConfigs from "../../../../../utils/headerGestorConfigs";
import DownloadOutlinedIcon from '@mui/icons-material/DownloadOutlined';
import Date from "../../../../../utils/date";
import RelatorioAnaliticoPdf from "./relatorioAnalitico/relatorioAnaliticoPdf";
import CertificadoAnaliticoPfd from "./certificadoAnalitico/certificadoAnaliticoPDF";
import AutorizacaoLote from "./autorizacao/autorizacaoLotePdf";


export default function DocumentosEmitidos({ avaliacaoAnalitica, imageDissolucao, imageTestePH, imageTesteVisual, imageTesteCromato }) {

    return (
        avaliacaoAnalitica &&
        <Card style={{ padding: 15, borderRadius: 5, marginTop: 20 }}>

            {avaliacaoAnalitica?.relatorioEmited &&
                <>
                    <HeaderGestorConfigs title={'DOCUMENTOS EMITIDOS'} />

                    <p>
                        <IconButton color="secondary" onClick={() => { RelatorioAnaliticoPdf(avaliacaoAnalitica, imageDissolucao, imageTestePH, imageTesteVisual, imageTesteCromato); }}>
                            <DownloadOutlinedIcon />
                        </IconButton>
                        RELATORIO ANALITICO {avaliacaoAnalitica?.numero} _ <Date date={avaliacaoAnalitica?.dataEnsaios} />
                    </p>
                </>
            }1

            {avaliacaoAnalitica?.certificadoEmited &&
                <p>
                    <IconButton color="secondary" onClick={() => { CertificadoAnaliticoPfd(avaliacaoAnalitica); }}>
                        <DownloadOutlinedIcon />
                    </IconButton>
                    CERTIFICADO {avaliacaoAnalitica?.numero} _ <Date date={avaliacaoAnalitica?.certificadoEmitedAt} />
                </p>
            }

            {avaliacaoAnalitica?.autorizacaoEmited &&
                <p>
                    <IconButton color="secondary" onClick={() => { AutorizacaoLote(avaliacaoAnalitica); }}>
                        <DownloadOutlinedIcon />
                    </IconButton>
                    AUTORIZAÇĀO {avaliacaoAnalitica?.numero} _ <Date date={avaliacaoAnalitica?.autorizacaoEmitedAt} />
                </p>
            }
        </Card>
    )
}
